/**
 * MatchBreadcrumb - Back navigation when viewing single match photos
 */
import styles from './MatchBreadcrumb.module.css';

export default function MatchBreadcrumb({ match, photoCount, isLive, onBack }) {
  const title = match
    ? `${match.home_team_name} vs ${match.away_team_name}`
    : 'Unassigned Photos';

  return (
    <div className={styles.breadcrumb}>
      <button className={styles.backButton} onClick={onBack} type="button">
        <svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor">
          <path d="M10.354 3.646a.5.5 0 0 1 0 .708L6.707 8l3.647 3.646a.5.5 0 0 1-.708.708l-4-4a.5.5 0 0 1 0-.708l4-4a.5.5 0 0 1 .708 0z"/>
        </svg>
        All Matches
      </button>
      <span className={styles.separator}>/</span>
      <span className={styles.current}>
        {title}
        <span className={styles.count}>{photoCount} photos</span>
        {isLive && <span className={styles.liveBadge}>LIVE</span>}
      </span>
    </div>
  );
}
